<template>
  <div style="float: left;margin-top: 10px;">
    <div class="m-form__group m-form__group--inline">
      <div class="m-form__label">
        <label style="width: 100px;text-align:right;">{{label}}：</label>
      </div>
      <div class="m-form__control">
        <el-select v-model="value" filterable placeholder="全部" @change="change">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in options" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="d-md-none m--margin-bottom-10"></div>
  </div>
</template>

<script>
export default {
  name: 'ZPGLSearchDictItemSelect',
  data () {
    return {
      options: [],
      value: '',
      rolelevel: '',
      userid: ''
    }
  },
  props: {
    label: {
      type: String
    },
    dictid: {
      type: Number
    }
  },
  methods: {
    change: function (selVal) {
      this.$emit('input', selVal)
    }
  },
  mounted: function () {
    this.rolelevel = sessionStorage.getItem('rolelevel')
    this.userid = sessionStorage.getItem('userid')
    var that = this
    var args = {
      token: sessionStorage.getItem('token'),
      dictid: this.dictid,
      rolelevel: this.rolelevel,
      userid: this.userid
    }
    this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/DictList', args, function (data) {
      that.options = data.Data
    }, null, null, null)
  }
}
</script>

<style>
</style>
